"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPacketValidationTypes = exports.workPacketGeneratorStates = exports.workPacketAssignmentStatuses = exports.workPacketStatuses = void 0;
/**
 * Lifecycle of a `work_packet` from the operator's perspective.
 *
 * Unlike `microtask_assignment`, there is no `IN_PROGRESS` state at the packet
 * level — an individual worker's progress is tracked on the
 * `work_packet_assignment` instead.
 *
 * Terminal states:
 *
 * - `INCOMPLETE`: still accepting assignments. Either no acceptance target is
 *   set (e.g. `m = ALL` strategies) or the target hasn't been met and the
 *   `max_attempts` safety brake hasn't fired.
 * - `COMPLETED`: the acceptance target was met —
 *   `accepted_assignment_count >= target_accepted_assignments`.
 * - `EXHAUSTED`: the safety brake fired before the target was met —
 *   `assignment_count >= max_attempts AND accepted_assignment_count < target_accepted_assignments`.
 *   Surfaces packets that produced too many rejections to be salvaged
 *   automatically, so the operator can triage them.
 */
exports.workPacketStatuses = ['INCOMPLETE', 'COMPLETED', 'EXHAUSTED'];
/**
 * Lifecycle of a single `work_packet_assignment` (one packet, one worker).
 * `IN_PROGRESS` is present here (unlike `WorkPacketStatus`) because an
 * individual worker can be midway through a packet without affecting the
 * packet's global status.
 */
exports.workPacketAssignmentStatuses = [
    'ASSIGNED',
    'IN_PROGRESS',
    'SUBMITTED',
    'VALIDATED',
    'COMPLETED',
    'EXPIRED',
    'REJECTED',
];
/**
 * `task.generator_state` for v2 tasks. Defaults to `RUNNING`; the operator
 * flips it to `HALTED` via `POST /tasks/:id/halt-generator` (PR 17) to declare
 * "no more inputs are coming." Required by the 8 packet-coverage termination
 * conditions in the allocation strategy catalog.
 */
exports.workPacketGeneratorStates = ['RUNNING', 'HALTED'];
/**
 * Allowed `WorkPacketValidationStrategy.type` discriminators.
 */
exports.workPacketValidationTypes = ['NONE', 'FULL', 'SAMPLE', 'GOLD', 'AUTO_ACCEPT'];
//# sourceMappingURL=Types.js.map